import { render, staticRenderFns } from "./SendTemplate.vue?vue&type=template&id=9332e594&scoped=true"
import script from "./SendTemplate.vue?vue&type=script&lang=js"
export * from "./SendTemplate.vue?vue&type=script&lang=js"
import style0 from "./SendTemplate.vue?vue&type=style&index=0&id=9332e594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9332e594",
  null
  
)

export default component.exports